import { render, staticRenderFns } from "./DataMonitoring.vue?vue&type=template&id=51422df8&scoped=true"
import script from "./DataMonitoring.vue?vue&type=script&lang=js"
export * from "./DataMonitoring.vue?vue&type=script&lang=js"
import style0 from "./DataMonitoring.vue?vue&type=style&index=0&id=51422df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51422df8",
  null
  
)

export default component.exports